import React from "react";

import cx from "@hsl/core/utils/cx";

interface Props extends React.PropsWithChildren {
    className?: string;
    title?: React.ReactNode;
    titleClassName?: string;
}

const SidebarSection = ({
    title,
    children,
    className,
    titleClassName,
}: Props) => {
    let TitleElem = null;
    if (title) {
        if (typeof title === "string") {
            TitleElem = (
                <SidebarSectionTitle className={titleClassName}>
                    {title}
                </SidebarSectionTitle>
            );
        } else {
            TitleElem = title;
        }
    }

    return (
        <div className={cx("w-full lg:pl-3", className)}>
            {TitleElem}
            {children}
        </div>
    );
};

export default SidebarSection;

export const SidebarSectionTitle = ({
    className,
    children,
}: { className?: string } & React.PropsWithChildren) => (
    <h2
        className={cx(
            "mb-2 border-b border-gray-300 pb-2 font-medium",
            className,
        )}
    >
        {children}
    </h2>
);
